import axios from 'axios';
import { ApiResponse, zps_auth } from '../zps';
import { IEntity } from '../entity';
import { IUser } from '../user';

export interface LoginBody {
  entid: number | string;
  uid?: number | string;
  email?: string;
  password: string;
}

export interface ILoginResponse extends ApiResponse {
  token: string;
  user: IUser;
  entity: IEntity;
  equipmentTypes: number[];
}

export const fetchLogin = (body: LoginBody) => {
  return axios.post<ILoginResponse>(`${zps_auth}/api/authenticate`, body);
};
